import { Form, Input, Radio } from "antd";
import { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import SearchAddress from "../../../../../../utils/searchAdrress";
import UploadCropCustom from "../../../../../../components/ImageUpload/crop";
import HtmlCustomEditor from "../../../../../../components/HtmlCustomEditor";
import "./index.css";

interface IProps {
  isDefalutOpen?: boolean;
  setIsPaidState: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProgramOutline = ({ isDefalutOpen = false, setIsPaidState }: IProps) => {
  const [isProgramOutlineOpen, setIsProgramOutlineOpen] =
    useState<boolean>(isDefalutOpen);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          cursor: "pointer",
          paddingBottom: "20px",
        }}
        onClick={() => setIsProgramOutlineOpen((q) => !q)}
      >
        <div style={{ fontSize: "20px", fontWeight: 600 }}>
          프로그램 개요
          <span style={{ color: "var(--ant-color-error)" }}>*</span>
        </div>
        {isProgramOutlineOpen ? <DownOutlined /> : <UpOutlined />}
      </div>
      <div style={{ position: "relative", height: "1px" }}>
        <div
          style={{
            position: "absolute",
            left: "-20px",
            width: "calc(100% + 40px)",
            height: "1px",
            backgroundColor: "var(--ant-layout-footer-bg)",
          }}
        />
      </div>
      <div
        style={{
          transition: "max-height 0.3s ease, margin-block 0.4s ease",
          maxHeight: isProgramOutlineOpen ? "500vh" : "0",
          overflow: "hidden",
          marginBlock: isProgramOutlineOpen ? "24px" : "0",
        }}
      >
        <Form.Item
          name="isDisplay"
          label="게시"
          rules={[{ required: true, message: "게시 여부를 선택해주세요" }]}
        >
          <Radio.Group>
            <Radio value={true}>게시</Radio>
            <Radio value={false}>미게시</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="title"
          label="프로그램명"
          rules={[{ required: true, message: "프로그램명을 입력해주세요" }]}
        >
          <Input.TextArea
            autoSize={true}
            placeholder="프로그램명을 입력해주세요"
            showCount
            maxLength={50}
          />
        </Form.Item>
        <Form.Item
          name="description"
          label="설명"
          rules={[{ required: true, message: "설명을 입력해주세요" }]}
        >
          <Input.TextArea
            autoSize={true}
            placeholder="간단한 설명을 입력해주세요"
            showCount
            maxLength={100}
          />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.isBooking !== currentValues.isBooking ||
            prevValues.isOnline !== currentValues.isOnline ||
            prevValues.isPaid !== currentValues.isPaid
          }
        >
          {({ getFieldValue }) => (
            <>
              <Form.Item
                name="isPaid"
                label="유/무료"
                rules={[
                  { required: true, message: "유/무료 여부를 선택해주세요" },
                ]}
              >
                <Radio.Group
                  disabled={getFieldValue("isBooking")}
                  onChange={(e) => setIsPaidState(e.target.value)}
                >
                  <Radio value={true}>유료</Radio>
                  <Radio value={false}>무료</Radio>
                </Radio.Group>
              </Form.Item>
              {getFieldValue('isPaid') &&
                <Form.Item
                  name="isAutoApprovalEnabled"
                  label="자동승인"
                  initialValue={false}
                >
                  <Radio.Group>
                    <Radio value={true}>자동</Radio>
                    <Radio value={false}>수동</Radio>
                  </Radio.Group>
                </Form.Item>}
              <Form.Item
                name="isOnline"
                label="구분"
                rules={[{ required: true, message: "구분을 선택해주세요" }]}
              >
                <Radio.Group disabled={getFieldValue("isBooking")}>
                  <Radio value={false}>오프라인</Radio>
                  <Radio value={true}>
                    <span>온라인</span>
                    <span
                      style={{
                        marginLeft: "16px",
                        color: "var(--ant-color-text-description)",
                      }}
                    >
                      ※ 온라인은 LIVE(ZOOM) 링크를 입력해 주세요.
                    </span>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </>
          )}
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.isOnline !== currentValues.isOnline
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("isOnline") && (
              <Form.Item name="onlineUrl" label="URL">
                <Input
                  disabled={getFieldValue("isBooking")}
                  placeholder="https://"
                />
              </Form.Item>
            )
          }
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.isOnline !== currentValues.isOnline
          }
        >
          {({ getFieldValue }) =>
            !getFieldValue("isOnline") && <SearchAddress />
          }
        </Form.Item>

        <Form.Item
          name="thumbnailImageUrl"
          label="목록 썸네일"
          valuePropName="fileList"
          rules={[{ required: true, message: "목록 썸네일을 등록해주세요" }]}
        >
          <UploadCropCustom
            style={{ display: "flex", gap: "24px" }}
            imgCropAspect={[960, 540]}
            sizeLimit={1}
          >
            <div style={{ color: "var(--ant-color-text-description)" }}>
              ※ 이미지 사이즈: 960(w) * 540(h) px (jpg, png 1MB 이하)
              <br />※ 탐색 메인화면에 노출됩니다.
            </div>
          </UploadCropCustom>
        </Form.Item>

        <Form.Item
          name="detailImageUrlList"
          label="상세 썸네일"
          valuePropName="fileList"
          rules={[{ required: true, message: "상세 썸네일을 등록해주세요" }]}
        >
          <UploadCropCustom
            style={{ display: "flex", gap: "24px" }}
            maxImg={5}
            imgCropAspect={[1125, 1125]}
            sizeLimit={1}
          >
            <div style={{ color: "var(--ant-color-text-description)" }}>
              ※ 이미지 사이즈: 1125(w) * 1125(h) px (jpg, png 1MB 이하, 최대
              5장)
              <br />※ 상세화면 상단에 노출됩니다.
            </div>
          </UploadCropCustom>
        </Form.Item>
        <Form.Item
          name="detailHtml"
          label="상세 내용"
          valuePropName="htmlData"
          rules={[{ required: true, message: "상세 내용을 입력해주세요" }]}
        >
          <HtmlCustomEditor
            className="wellness-program-http-custom-editor"
            style={{ width: "377px" }}
          />
        </Form.Item>
        <Form.Item
          name="notificationHtml"
          label="안내사항"
          valuePropName="htmlData"
          rules={[{ required: true, message: "안내사항을 입력해주세요" }]}
        >
          <HtmlCustomEditor
            className="wellness-program-http-custom-editor"
            style={{ width: "377px" }}
          />
        </Form.Item>

        <Form.Item
          name="refundNotiHtml"
          label="취소 ・ 환불 규정"
          valuePropName="htmlData"
          rules={[
            { required: true, message: "취소 ・ 환불 규정을 입력해주세요" },
          ]}
        >
          <HtmlCustomEditor
            className="wellness-program-http-custom-editor"
            style={{ width: "377px" }}
          />
        </Form.Item>
      </div>
    </>
  );
};

export { ProgramOutline };
